export default {
  addPlugin: {
    method: 'post',
    url: '/p/vehicle/plugin'
  },
  getPluginByVehicleId: {
    method: 'post',
    url: 'vehicle/plugin/list/ID'
  },
  removePlugin: {
    method: 'delete',
    url: 'vehicle/plugin'
  },
  changeStatus: {
    method: 'put',
    url: 'vehicle/plugin/status'
  },
  editPlugin: {
    method: 'put',
    url: 'vehicle/plugin/id'
  },
  getDetail: {
    method: 'get',
    url: 'vehicle/plugin/ID'
  }
}
